import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Typography, DialogActions, DialogContent, DialogTitle, Grid, IconButton, CircularProgress } from '@mui/material';
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { formatTimeStampToDate } from 'utilities/common';
import { validateDriverClosureForm } from "validations/hyperwolf/distributionmanagement";
import { closeCustomModalDialog, setModalLoader } from '../../../redux/slices/modalSlice';
import { forceClosureForm } from "../../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
// custom components
import MDButton from 'components/MDButton';

export default function DriverCloserForm({ closeModal }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user } = useSelector(state => state.auth || {});
  const { modalData, isLoading } = useSelector(state => state.modal);
  const { closureFormDetails } = modalData || {}

  const [details, setDetails] = useState({})
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async () => {
    try {
      const { myErrors, isValid } = validateDriverClosureForm(details)

      if (!isValid) {
        setErrors(myErrors);
        return;
      } else {
        setErrors({});
      }

      dispatch(setModalLoader(true));
      const { distributionId, regionId, subRegionId, driverId, date, cashReconciliation = {}, creditCardReconciliation = {} } = closureFormDetails || {}
      const request = {
        distributionId, regionId, subRegionId, driverId,
        cashReconciliation, creditCardReconciliation,
        closedBy: user?.name || "",
        date: formatTimeStampToDate(date),
        ...details,
      }

      const response = await dispatch(forceClosureForm({ ...request })).unwrap();
      dispatch(closeCustomModalDialog());

      if (response?.success) {
        showToastMsg(response?.message, 'success');
        navigate(-1, { replace: true })
        // navigate(`/hyperwolf/closure-forms/details/${distributionId}?driver=${driverId}&region=${regionId}&subRegion=${subRegionId}`, { replace: true })
      }
    } catch (err) {
      showToastMsg(err, 'error');
    } finally {
      dispatch(setModalLoader(false));
    };
  }

  return (
    <>
      <DialogTitle className='pt-4 px-4 pb-1'>
        <Typography variant="h4" fontWeight="bold">
          Close Driver Form
        </Typography>
        <IconButton onClick={closeModal} edge='end' size='small' style={{ position: "absolute", right: "24px", top: "24px" }}>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>

      <DialogContent className='px-4 py-0'>
        <Grid container spacing={3} className='mt-2'>
          {/* Discrepancy Note */}
          <Grid item xs={12}>
            <textarea
              placeholder='Add Note...'
              style={{
                width: "100%", minHeight: "100px", borderRadius: "20px", boxShadow: 'none', border: "1px solid #9A9AAF", overflow: "hidden", outline: "none", padding: "12px 20px", resize: "none"
              }}
              name="closedNotes"
              value={details?.closedNotes}
              onChange={handleChange}
            />
            {errors?.closedNotes && <p className="error">{errors?.closedNotes}</p>}
          </Grid>

        </Grid>
      </DialogContent >

      {/* Action buttons */}
      <DialogActions DialogActions className='footer-modal' style={{ marginBottom: "12px", justifyContent: "start", padding: "1em" }}>
        <MDButton
          sx={{ minWidth: '160px' }}
          color="primary"
          type='button'
          variant='contained'
          disabled={isLoading}
          onClick={handleSubmit}
        >
          {isLoading ? <CircularProgress size={22} color="light" /> : "Save"}
        </MDButton>
        <MDButton
          onClick={closeModal}
          sx={{ minWidth: '160px' }}
          type='button'
          variant='outlined'
          color='dark'
        >
          Cancel
        </MDButton>
      </DialogActions >
    </>
  );
}